import { vplApi } from '@/api';

export default {
  fetchCustomerServiceList() {
    return vplApi.get('/v1/customer-services');
  },
};
